// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__36fVD","head":"Table_head__Tf76J","col":"Table_col__1wHmR"};